export default "__VITE_PUBLIC_ASSET__bc2cbfb7__"